import gameData from "../../gameData";

export function createParticle(scene)
{
    const Particle = scene.add.particles('UIAssets','Donuts and Sprinkles/Sprinkle_Jimmy');
    const sprinkleHex = [0x14cec9,0xa792f1,0x86e950,0xcf7edd,0xefd63b,0xf070ad]

    const cLength = sprinkleHex.length;

    const Sparkler = Particle.createEmitter({
        frame: ['Donuts and Sprinkles/Sprinkle_Jimmy','Donuts and Sprinkles/Sprinkle_Dot'],
        x: 500,
        y: 400,
        tint:{onEmit: function () {  

            return sprinkleHex[Math.floor(Math.random()*cLength)] 
        }},
        accelerationY:500,
        lifespan: 4000,
        speed: {min:900, max:1300},
        angle: {min:250, max:290},
        gravityY: 1000,
        rotate:  {onEmit: function () {  return Math.floor(Math.random()*360) }},
        // alpha: { start: 1, end: 0 },
        // scale: { start:.5, end:1 },
        on: false
    });
    // Sparkler.emitParticleAt(512,768,90);
    Particle.setDepth(5);

    if(!gameData.started)
    {
        scene.events.on("correct",()=>{
            //this.image.destroy(); 
            scene.part.emitParticleAt(512,768,90);
        });
    }
    
    return Sparkler;
}